<template>
  <div class="table">
    <!--<div class="crumbs">-->
    <!--<el-breadcrumb separator="/">-->
    <!--<el-breadcrumb-item><i class="el-icon-lx-cascades">派单管理</i></el-breadcrumb-item>-->
    <!--</el-breadcrumb>-->
    <!--</div>-->
    <br />
    <div class="container">
      <div class="form-box">
        <el-form ref="form" :model="form" label-width="80px">
          <el-row>
<el-col :span="6">
            <el-form-item label="订单号:">
              <el-input v-model="form.orderNo" placeholder="订单号" ref="orderNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单类型:" prop="type" v-if="activeName==='1'">
              <el-select v-model="form.type" placeholder="请选择" ref="type" clearable>
                <el-option
                  v-for="item in orderTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
  <el-col :span="8" >
            <el-button style="margin-left:20px" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            <el-button
              type="primary"
              @click="handleListSet"
              :disabled="multipleSelection.length==0 ? true:false"
              v-if="activeName==='2'"
            >一键派单</el-button>
          </el-col>
          </el-row>
        </el-form>
      </div>
 
     
      <el-tabs @tab-click="handleClick" type="border-card" v-model="activeName">
        <el-tab-pane label="单个订单" name=1>
          <el-table :data="tableData" border class="table">
            <el-table-column prop="orderNo" label="订单号" width="180" align="center"></el-table-column>
            <el-table-column prop="typeStr" label="订单类型" width="100" align="center"></el-table-column>
            <el-table-column prop="orderStatusStr" label="订单状态" width="100" align="center"></el-table-column>
            <el-table-column
              prop="orderTime"
              label="下单时间"
              align="center"
              width="150"
              :formatter="dateFormat"
            ></el-table-column>

            <el-table-column prop="planDeparture" label="预计出发地" width="300" align="center"></el-table-column>
            <el-table-column prop="planDepartTime" label="预计上车时间" width="150" align="center"></el-table-column>
            <el-table-column prop="planDestination" label="预计目的地" width="300" align="center"></el-table-column>

            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <!--scope.$index：当前行的下标 ，  scope.row：当前行数据的集合-->
                <!-- <el-button
                  type="primary"
                  icon="el-icon-edit"
                  @click="handleset(scope.$index, scope.row)"
                >
                  <b>随机派单</b>
                </el-button> -->
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  @click="manualSendOrder(scope.$index, scope.row)"
                  :disabled="(new Date(scope.row.planDepartTime)).valueOf()< (new Date((new Date()).getTime() - 24*60*60*1000).valueOf())"
                >
                  <b>指定派单</b>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <br />
        </el-tab-pane>

        <el-tab-pane label="拼车订单" name=2>
          <el-table
            :data="tableData2"
            border
            class="table"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" align="center" :selectable="checkSelectable"></el-table-column>

            <el-table-column prop="orderNo" label="订单号" width="180" align="center"></el-table-column>
            <el-table-column prop="typeStr" label="订单类型" width="100" align="center"></el-table-column>
            <el-table-column prop="orderStatusStr" label="订单状态" width="120" align="center"></el-table-column>
            <el-table-column prop="passengerNum" label="乘车人数" width="100" align="center"></el-table-column>
            <el-table-column
              prop="orderTime"
              label="下单时间"
              align="center"
              width="150"
              :formatter="dateFormat"
            ></el-table-column>
            <el-table-column prop="planDeparture" label="预计出发地" width="300" align="center"></el-table-column>
            <el-table-column prop="planDepartTime" label="预计上车时间" width="150" align="center"></el-table-column>
            <el-table-column prop="planDestination" label="预计目的地" width="300" align="center"></el-table-column>

            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  @click="manualSendOrder(scope.$index, scope.row)"
                   :disabled="(new Date(scope.row.planDepartTime)).valueOf()< (new Date((new Date()).getTime() - 24*60*60*1000).valueOf())"
                >
                  <b>指定派单</b>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <br>
      <!--分页-->
      <div class="pagination" style="margin-left: 1000px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </div>

    <!-- 随机派单弹出框 -->
    <el-dialog title="随机派单" :visible.sync="editVisible" width="20%">
      <el-form ref="RandomForm" :model="RandomForm" label-width="80px">
        <el-form-item label="司机姓名">
          <el-input v-model="RandomForm.driverName" style="width: 194px;"></el-input>
        </el-form-item>

        <el-form-item label="车牌号">
          <el-input v-model="RandomForm.vehicleNo" style="width: 194px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveEdit">确认派单</el-button>
        <el-button @click="editVisible = false">取消派单</el-button>
      </span>
    </el-dialog>

    <!-- 指定司机派单弹出框 -->
    <el-dialog title="指定派单" :visible.sync="editVisibleTWO" width="20%">
      <el-form ref="sendForm" :model="sendForm" label-width="80px">
        <el-form-item label="司机电话">
          <el-input v-model="sendForm.driverPhone" style="width: 194px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSendOrder">确认派单</el-button>
        <el-button @click="editVisibleTWO = false">取消派单</el-button>
      </span>
    </el-dialog>

    <!-- 批量派单弹出框 -->
    <el-dialog title="批量派单" :visible.sync="editVisibleBatch" width="20%">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="选择司机:">
          <el-cascader
            size="large"
            :options="driverList"
            v-model="form.driverId"
            filterable
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveEditBatch">确认派单</el-button>
        <el-button @click="editVisibleBatch = false">取消派单</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import db from "@/utils/localstorage";
export default {
  name: "sendOrder",
  data() {
    return {
      tableData: [], //总数据
      tableData2: [],
      pageNum: 1, //默认显示第几页
      totalCount: 100, // 总条数，根据接口获取数据长度(注意：这里不能为空)
      pageSize: 10, // 默认每页显示的条数（可修改）
      multipleSelection: [],
      del_list: [],
      is_search: false,
      editVisible: false,
      editVisibleTWO: false,
      editVisibleBatch: false,
      delVisible: false,
      form: {
        orderNo: "",
        type: ""
      },
      activeName: "1",
      //随机派单
      RandomForm: {
        id: "",
        driverId: "",
        driverName: "",
        vehicleId: "",
        vehicleNo: ""
      },
      //指定派单
      sendForm: {
        id: "",
        driverPhone: ""
      },
      ids: [], //拼车订单多个订单id的数组
      driverList: [], //司机选项列表

      orderTypeOptions: [],
      value: "",
      idx: -1
    };
  },
  created() {
    this.getData(this.pageNum, this.pageSize);
    this.getOrderType();
  },

  computed: {},
  methods: {
    // 将页码，及每页显示的条数以参数传递提交给后台
    getData(n1, n2) {
      this.searchCommon(n1, n2);
    },
    // 分页
    // 每页显示的条数
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.pageSize = val;
      // 点击每页显示的条数时，显示第一页
      this.search();
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.pageNum = 1;
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.pageNum = val;
      // 切换页码时，要获取每页显示的条数
      this.searchPage();
    },

    handleClick(tab, event) {
      this.activeName = tab.name;
      //点击切换按钮时,清空前一个tab分页总数信息
      this.totalCount = 0;
      this.getData(1, this.pageSize);
    },

    //搜索框搜索 、改变分页显示的条数时的搜索
    search() {
      this.searchCommon(1, this.pageSize);
    },

    //点分页搜索
    searchPage() {
      this.searchCommon(this.pageNum, this.pageSize);
    },

    //查询公共方法
    searchCommon(pageNum, pageSize) {
      if (this.activeName === "1") {
        this.$post("pc_order/getOrderBySelectiveNoReceiving", {
          orderNo: this.form.orderNo,
          type: this.form.type,
          pageNum: pageNum,
          pageSize: pageSize
        })
          .then(res => {
            if (res.data.code === 0) {
              if (res.data.data != null) {
                this.tableData = res.data.data.list;
                // 将数据的长度赋值给totalCount
                this.totalCount = res.data.data.total;
              }
            }
          })
          .catch(error => {
            this.$message.error(error.message);
          });
      } else if (this.activeName === "2") {
        this.$post("pc_order/getOrderCarpoolByWaitingReceiving", {
          orderNo: this.form.orderNo,
          pageNum: pageNum,
          pageSize: pageSize
        })
          .then(res => {
            if (res.data.code === 0) {
              let d = res.data.data;
              if (d != null) {
                this.tableData2 = d.list;
                // 将数据的长度赋值给totalCount
                this.totalCount = d.total;
              }
            }
          })
          .catch(error => {
            alert(error);
          });
      }
    },

    //获取订单类型选项
    getOrderType() {
      let orderTypes = db.get("orderTypes");
      if (orderTypes != null && JSON.stringify(orderTypes) != "{}") {
        this.orderTypeOptions = orderTypes;
      } else {
        this.$post("pc_dict/getOrderTypeList", {}).then(result => {
          if (result.data.code === 0) {
            this.orderTypeOptions = result.data.data;
            db.save("orderTypes", result.data.data);
          }
        });
      }
    },

    checkSelectable(row){
      if((new Date(row.planDepartTime)).valueOf()< (new Date((new Date()).getTime() - 24*60*60*1000)).valueOf()){
        return false;
      }else{
        return true;
      }
    },

    /**********************操作自动匹配司机派单************************************************/
    //操作派单
    handleset(index, row) {
      //请求之前先清空前一次的缓存数据
      this.RandomForm.driverId = "";
      this.RandomForm.driverName = "";
      this.RandomForm.vehicleId = "";
      this.RandomForm.vehicleNo = "";

      // var that = this
      this.idx = index;
      const item = this.tableData[index];
      this.RandomForm.id = item.id;
      this.$post("pc_order/sendOrdersInfo", {
        id: item.id
      })
        .then(res => {
          // console.log(res)
          //res为后端返回的结果集，当code为0时，表示查询成功.此处调用接口 后端返回code是状态码，
          if (res.data.code === 0) {
            let datas = res.data.data;
            if (datas != null) {
              this.RandomForm.driverId = datas.driverId;
              this.RandomForm.driverName = datas.driverName;
              this.RandomForm.vehicleId = datas.vehicleId;
              this.RandomForm.vehicleNo = datas.vehicleNo;
            }
          } else {
            this.$message.warning(res.data.msg);
            this.editVisible = false;
          }
        })
        .catch(error => {
          // 					alert("信息获取失败，请联系管理员")
          // 					console.log(error.message)
          //如果待接单司机数为0，会抛出异常"Cannot read property 'driverId' of null"
          if (error.message === "Cannot read property 'driverId' of null") {
            this.$message.warning("抱歉,附近暂时无可派车辆,请稍后重试");
          }
        });
      this.editVisible = true;
    },

    //保存随机派单信息
    saveEdit() {
      this.$post("pc_order/manualSendOrder", {
        orderId: this.RandomForm.id,
        driverId: this.RandomForm.driverId
      })
        .then(res => {
          //alert(res.data.code);
          if (res.data.code === 0) {
            this.editVisible = false;
            this.$message.success("派单成功");
          } else {
            this.$message.warning(res.data.msg);
            this.editVisible = false;
          }
          //派单成功后，调用获取当前页面数据方法，相当于及时刷新页面
          this.getData(this.pageNum, this.pageSize);
        })
        .catch(error => {
          // console.log(error.message)
          this.$message.warning(error.message);
        });
    },

    /**********************操作指定司机派单************************************************/
    //操作指定司机派单
    manualSendOrder(index, row) {
      this.idx = index;
      const item = this.tableData[index];
      this.sendForm.id = item.id;
      this.editVisibleTWO = true;
    },

    //保存指定派单信息
    saveSendOrder() {
      let orderId = this.sendForm.id;
      let driverPhone = this.sendForm.driverPhone;
      if (orderId === "" || driverPhone === "") {
        this.$message.warning("请输入司机联系方式");
        return false;
      }

      this.$post("pc_order/manualSendOrder", {
        orderId: orderId,
        driverPhone: driverPhone
      })
        .then(res => {
          if (res.data.code === 0) {
            this.$message.success("派单成功");
          } else {
            this.$message.warning(res.data.msg);
          }
          this.editVisibleTWO = false;
          this.getData(this.pageNum, this.pageSize);
        })
        .catch(error => {
          this.$message.warning(error.message);
        });
    },

    //操作批量派单
    //去后台请求获取司机选项列表
    handleListSet() {
      //为了避免缓存，当点击时清空列表后再去后台请求
      this.driverList = [];
      this.$post("pc_driver/getTourneoDriver", {})
        .then(res => {
          if (res.data.code === 0) {
            if (res.data.data != null) {
              this.driverList = res.data.data;
            } else {
              this.$message.warning("附近暂无可派司机");
            }
          } else {
            alert(res.data.msg);
            this.editVisibleBatch = false;
          }
        })
        .catch(error => {
          this.$message.error(error);
        });
      this.editVisibleBatch = true;
    },

    //保存批量派单信息
    saveEditBatch() {
      if (this.ids.length <= 0) {
        this.$message.warning("请选择派单的订单");
        this.editVisibleBatch = false;
        return false;
      }
      if (this.form.driverId === "") {
        this.$message.warning("请选择派单的司机");
        return false;
      }
      console.log(this.ids);
      this.$post("pc_order/manualSendCarpoolOrder", {
        ids: Array.from(new Set(this.ids)), //去除数组中的重复值，并生成新的数组
        driverId: this.form.driverId
      })
        .then(res => {
          //alert(res.data.code);
          if (res.data.code === 0) {
            this.$message.success("派单成功");
          } else {
            this.$message.warning(res.data.msg);
          }
          this.editVisibleBatch = false;
          this.getData(this.pageNum, this.pageSize);
          this.ids = [];
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          this.ids.push(val[i].id);
        }
      }
    },

    formatter(row, column) {
      return row.address;
    },
    filterTag(value, row) {
      return row.tag === value;
    },

    //格式转换，直接复制即可
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    formatRole(row, column) {
      return row.gender === "1" ? "男" : row.gender === "2" ? "女" : "秘密";
    },
    //时间格式化
    dateFormat: function(row, column) {
      var ut = row[column.property];
      var t = new Date(ut);
      return (
        t.getFullYear() +
        "-" +
        (t.getMonth() + 1) +
        "-" +
        t.getDate() +
        " " +
        t.getHours() +
        ":" +
        t.getMinutes() +
        ":" +
        t.getSeconds()
      );
    },
    //状态格式化
    stateFormat(row, column) {
      return row.state == "1" ? "正常" : row.state == "0" ? "风险用户" : "未知";
    }
  }
};
</script>

<style scoped>
.form-box {
  width: 60.5rem;
}

.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}

.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/managers/SendOrder.vue